<!-- <app-header position="fixed-top" [showBackButton]="false"></app-header> -->
 <banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>
<section class="bg-fondo-3 onerous-section spacing-section spacing-top">
    <div class="container">

        <app-details-vehicle-banner></app-details-vehicle-banner>


        <h1 class="my-5 main-title">¿Tu moto tiene alguna de estas características?</h1>


        <div class="onerous_feature">
 <article class="onerous_feature-item mb-3">
                <img src="./assets/img/svg/Certificado.svg" alt="">
                <span class="onerous_feature-info">
                    <h5 class="onerous_feature-info-title">
                        Moto nueva (0 km)
                    </h5>
                    <p>Si acaba de salir del concesionario</p>
                </span>

                <fieldset>
                    <label class="switch">
                        <input type="checkbox" [ngModel]="checkCeroKM()" (ngModelChange)="checkCeroKM.set($event)">
                        <span class="slider round"></span>
                    </label>
                </fieldset>
            </article>

            <article class="onerous_feature-item mb-3">
                <img src="./assets/img/svg/Moneda.svg" alt="">
                <span class="onerous_feature-info">
                    <h5 class="onerous_feature-info-title">
                        Moto financiada
                    </h5>
                    <p>Si tiene prenda con un banco</p>
                </span>

                <fieldset>
                    <label class="switch">
                        <input type="checkbox" [ngModel]="checkFinanced()" (ngModelChange)="checkFinanced.set($event)">
                        <span class="slider round"></span>
                    </label>
                </fieldset>
            </article>

            <article class="onerous_feature-item mb-3">
                <img src="./assets/img/svg/Escudo-seguro.svg" alt="">
                <span class="onerous_feature-info">
                    <h5 class="onerous_feature-info-title">
                        Accesorios adicionales
                    </h5>
                    <p>Alarma, manilares térmicos</p>
                </span>

                <fieldset>
                    <label class="switch">
                        <input type="checkbox" [ngModel]="checkAccessories()"
                            (ngModelChange)="checkAccessories.set($event)">
                        <span class="slider round"></span>
                    </label>
                </fieldset>
            </article>

           




            <div class="onerous_actions">
                <app-button [text]="buttonTitle()" [type]="'primary'" [size]="'small'" [witch]="'fullwidth'"
                    (clicked)="handleClick()"></app-button>
            </div>
        </div>



    </div>
</section>
<app-footer-app class="footer-fixed" />